export default __webpack_public_path__ + "media/images/35-f47d49e7affb2c87b813c887fdc97c56.png";